module.exports = __webpack_public_path__ + "img/notification.b5b5b0b8.svg";